import { Folder, Tag } from 'iconsax-react';

const icons = {
    folder: Folder,
    tag: Tag,
};

const projectsItem = {
    id: 'projects-group',
    // title: 'Projects',
    type: 'group',
    children: [
        {
            id: 'all-projects',
            title: 'All Projects',
            type: 'item',
            url: '/projects/all-projects',
            icon: icons.folder,
            breadcrumbs: true
        },
        {
            id: 'old-tag-numbers',
            title: 'Old Tag Numbers',
            type: 'item',
            url: '/projects/old-tags',
            icon: icons.tag,
            breadcrumbs: true
        },
    ]
};

export default projectsItem;
